/* Format Date Cells */
import { formatDuration, intervalToDuration } from 'date-fns';

export const dateFormatter = (params) => {
    return params.value ? new Date(params.value).toLocaleDateString( {
        weekday: 'long',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    }) : "";
};

export const formatTimeDifference = (difference) => {
    const seconds = Math.floor(difference / 1000);
    return formatTimeDifferenceSeconds(seconds);
}

export const formatTimeDifferenceSeconds = (difference) => {
    const seconds = difference;
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    
    if (hours > 0) return `${hours} h ${minutes % 60} m`;
    if (minutes > 0) return `${minutes} m ${seconds % 60} s`;
    return `${seconds} s`;    
}

export const getDate = (date) => {
    return new Date(date);
}
export const dateTimeFormatter = (params) => {
    let date = "--"
    
    if (params.value?.timestamp !== undefined) {
        date = params.value.timestamp 
    }
    else if (params.value !== null) {
        date = params.value
    }
    
    if (date !== "--") {
        return date ? getDate(date).toLocaleString( {
            //include hours and minutes
            weekday: 'long',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        }) : "--";
    }
    else {
        return date
    }
};

export const durationFormatter = (duration) => {
    
    if(duration === 0 || duration === null)
    {
        return '0 sec(s)'
    }
    const durationInMilliseconds = duration * 1000;
    const toDuration = intervalToDuration({ start: 0, end: durationInMilliseconds });
    return formatDuration(toDuration).replace(/seconds/g, 'sec(s)');
}

export const durationStateFormatter = (duration, jobState) => {
    if(jobState === 'Completed' || jobState === 'Failed') {
        return durationFormatter(duration);
    }
    return '-- sec(s)';
}

export const durationTaskFormatter = (duration, jobState) => {
    if(jobState === 'Draft') {
        return '-- sec(s)';
    }
    return durationFormatter(duration);
}

export const taskProgressFormatter = (progress) => {
    
    if(progress < 1.0) {
    
        return (progress * 100).toFixed(2) + '%';
    }
    return (Math.floor(progress) * 100).toFixed(2) + '%';
}

export const fileSizeFormatter = (params) => {
    if(params.value < fileSizes.kbInBytes)
    {
        if (params.value === 1)
            return params.value + " byte";
        return params.value + " bytes";
    }
    if(params.value < fileSizes.mbInBytes)
        return (params.value/fileSizes.kbInBytes).toFixed(2) + " KB";
    if(params.value < fileSizes.gbInBytes)
        return (params.value/fileSizes.mbInBytes).toFixed(2) + " MB";
    if(params.value < fileSizes.tbInBytes)
        return (params.value/fileSizes.gbInBytes).toFixed(2) + " GB";
    else
        return (params.value/fileSizes.tbInBytes).toFixed(2) + " TB";
    
}


const fileSizes = {
    kbInBytes : 1000,
    mbInBytes : 1000000,
    gbInBytes : 1000000000,
    tbInBytes : 1000000000000,
}

const timeDurations = {
    minInSec : 60,
    hourInSec : 3600,
    dayInSec : 86400,
}